import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";

const MasterDashboard = () => {
  const navigate = useNavigate();

  return (
    <Box p={4}>
      <Typography variant="h4">Master Dashboard</Typography>
      <Button
        variant="outlined"
        onClick={() => navigate("superadmins")}
        sx={{ mt: 2 }}
      >
        Manage Super Admins
      </Button>
      <Button
        variant="contained"
        onClick={() => {
          logout();
          navigate("/login");
        }}
        sx={{ mt: 2 }}
      >
        Logout
      </Button>
    </Box>
  );
};

export default MasterDashboard;
